var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("LayoutAuth", [
    _c(
      "form",
      {
        staticClass: "form form--auth",
        attrs: { novalidate: "" },
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.resetPassword.apply(null, arguments)
          },
        },
      },
      [
        _c("h1", { staticClass: "h2" }, [_vm._v("Reset Password")]),
        _vm._v(" "),
        _c("p", { staticClass: "form__subtitle" }, [
          _vm._v("Enter a new password below."),
        ]),
        _vm._v(" "),
        _c("ValidationAlert", {
          attrs: { "error-list": _vm.errors.collect("server") },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "form__group" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.formData.email,
                expression: "formData.email",
              },
              { name: "validate", rawName: "v-validate" },
            ],
            staticClass: "form__control",
            attrs: {
              id: "email",
              type: "email",
              name: "email",
              placeholder: "Enter your email address here...",
              required: "",
              autocomplete: "username",
            },
            domProps: { value: _vm.formData.email },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.formData, "email", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _c("label", { staticClass: "form__label", attrs: { for: "email" } }, [
            _vm._v("Email Address"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form__validation" }, [
            _vm._v(_vm._s(_vm.errors.first("email"))),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form__group" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.formData.password,
                expression: "formData.password",
              },
              {
                name: "validate",
                rawName: "v-validate",
                value: "confirmed:password-confirm",
                expression: "'confirmed:password-confirm'",
              },
            ],
            staticClass: "form__control",
            attrs: {
              id: "password",
              type: "password",
              name: "password",
              placeholder: "Enter your new password here...",
              required: "",
              autocomplete: "new-password",
            },
            domProps: { value: _vm.formData.password },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.formData, "password", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _c(
            "label",
            { staticClass: "form__label", attrs: { for: "password" } },
            [_vm._v("New Password")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "form__validation" }, [
            _vm._v(_vm._s(_vm.errors.first("password"))),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form__group" }, [
          _c("input", {
            directives: [{ name: "validate", rawName: "v-validate" }],
            staticClass: "form__control",
            attrs: {
              id: "password-confirm",
              type: "password",
              name: "password-confirm",
              placeholder: "Re-enter your new password here...",
              required: "",
              autocomplete: "new-password",
            },
          }),
          _vm._v(" "),
          _c(
            "label",
            { staticClass: "form__label", attrs: { for: "password-confirm" } },
            [_vm._v("Confirm New Password")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "form__validation" }, [
            _vm._v(_vm._s(_vm.errors.first("password-confirm"))),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form__group form__group--submit" }, [
          _c(
            "button",
            {
              staticClass: "btn btn--primary",
              attrs: {
                type: "submit",
                disabled: _vm.$wait.is("resetPassword"),
              },
            },
            [_vm._v("Reset password")]
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }